'use strict';

import { showToast } from '../utils/ShowToast';
import { isParcelPage, translations as t } from './parcel-page';

const STATUS_CLASS_MAP = {
  OK:                   'btn-success',
  INCORRECT_CONTENT:    'btn-warning',
  INCORRECTLY_EXPORTED: 'btn-danger',
  UNEXPORTED:           'btn-secondary',
  UNRECEIVED:           'btn-info',
  NOT_INSPECTED:        'btn-outline-secondary',
};

function changeInspectionStatus(parcelId, status, statusLabel, icon) {
  const $button       = $('#current-status-btn');
  const $statusText   = $('#current-status-text');
  const originalText  = $statusText.html();
  const originalClass = $button.attr('class');
  const url = $('.dropdown-menu[data-change-status-url]').data('change-status-url');

  $statusText.empty().append(
    $('<i>').addClass('fa fa-spinner fa-spin'),
    document.createTextNode(' ' + t.waiting)
  );
  $button.prop('disabled', true);

  $.ajax({
    url:      url,
    method:   'POST',
    data:     { parcelId: parcelId, status: status },
    dataType: 'json',
    success: function (data) {
      if (data.success) {
        $statusText.empty().append(
          $('<i>').addClass('fa fa-fw me-1').addClass(icon),
          document.createTextNode(' ' + statusLabel)
        );

        $button
          .attr('class', originalClass
            .split(' ')
            .filter((c) => !c.startsWith('btn-') || c === 'btn' || c === 'btn-sm')
            .join(' ')
          )
          .addClass(STATUS_CLASS_MAP[status] ?? 'btn-outline-secondary')
          .addClass('dropdown-toggle');

        showToast('success', t.success, data.message);
      } else {
        showToast('error', t.error, data.message);
        $statusText.html(originalText);
        $button.attr('class', originalClass);
      }

      $button.prop('disabled', false);
    },
    error: function () {
      showToast('error', t.error, t.connectionFailed);
      $statusText.html(originalText);
      $button.attr('class', originalClass);
      $button.prop('disabled', false);
    },
  });
}

$(function () {
  if (!isParcelPage()) return;

  $(document).on('click', '.dropdown-item[data-status]', function () {
    changeInspectionStatus(
      $(this).data('parcel-id'),
      $(this).data('status'),
      $(this).data('status-label'),
      $(this).data('icon')
    );
  });

  $(document).on('click', '.js-print-thermal', function () {
    window.printParcelConfirmation($(this).data('parcel-id'));
  });

  $(document).off('click.parcelPrint').on('click.parcelPrint', '.js-print-packets', function (e) {
    e.preventDefault();

    const $iframe = $('<iframe>')
      .css({ position: 'fixed', top: '-9999px', left: '-9999px', width: '1px', height: '1px' })
      .attr('src', $(this).attr('href'))
      .appendTo('body');

    $iframe.on('load', function () {
      $iframe[0].contentWindow.print();
      setTimeout(() => $iframe.remove(), 1000);
    });
  });

  $(document).on('click', '#parcel-note-submit', function () {
    const $btn  = $(this);
    const $icon = $btn.find('i');
    const $input = $('#parcel-note-input');
    const note  = $input.val().trim();

    if (!note) return;

    $btn.prop('disabled', true);
    $icon.removeClass('fa-circle-plus').addClass('fa-spinner fa-spin');

    $.nette.ajax({
      url:    $btn.data('url'),
      method: 'POST',
      data:   { note: note, barcode: $btn.data('barcode') },
      success: function (payload) {
        if (payload.success) {
          $input.val('');
          showToast('success', t.success, payload.message);
        } else {
          showToast('error', t.error, payload.message);
        }
      },
      error: function () {
        showToast('error', t.error, t.connectionFailed);
      },
      complete: function () {
        $btn.prop('disabled', false);
        $icon.removeClass('fa-spinner fa-spin').addClass('fa-circle-plus');
      },
    });
  });
});
